
import Loading from 'vux/src/components/loading/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import dateFormat from 'vux/src/tools/date/format.js'

import { questionNewList } from '@/api/evaluation'
export default {
components: {
Loading,
XHeader,
Group,
Cell,
Card,
Radio,
XButton
},
data () {
return {
isDevBak: false,
loading: true,
time: '',

params: {"appName":null,"au":"VS8rOW5LdmM2aVE2WFp3M1VtTHBiMnkwa09jN043TExHb01NU1BTbkFZeG1kQlpJK3dTYk9qa1IyZ0g4dzFhdw==","invenstemUserId":8023,"mac":null,"managerId":7956,"os":null,"platformUserId":8022,"productId":0,"productUrl":null,"specialObj":false,"stepCurrent":0,"stepTotal":0,"sysCode":"1003","type":null,"userId":8023,"userName":"李彬杰","userType":null,"version":null},

stepCurrent: 0,
stepTotal: 4,
question: {}
}
},
created () {
this.$vux.loading.show({text: '加载中'})
this.$_evaluation_time()
this.$_evaluation_init()
},
methods: {
$_evaluation_back () {
this.$bridge.callHandler('finish', {message: '关闭h5'}, function (data) {
console.log('finish')
})
},
$_evaluation_time () {
this.time = dateFormat(new Date(), 'YYYY-MM-DD HH:mm:ss')
setInterval(() => {
this.time = dateFormat(new Date(), 'YYYY-MM-DD HH:mm:ss')
}, 1000)
},
$_evaluation_init () {
let _this = this
setTimeout(() => {
if (_this.isDevBak) {
this.questionNewList().then(() => {
_this.$vux.loading.hide()
_this.loading = false
})
} else {
_this.$bridge.callHandler('getUserInfo', {message: '获取用户信息: managerId,userId,userName,sysCode(1003,1004), au'}, async (data) => {
_this.$vux.loading.hide()
let res = JSON.parse(data)
console.log(res)
if (res.userName && res.userId && res.managerId && res.sysCode && res.au) {
this.params.userName = res.userName
this.params.userId = parseInt(res.userId)
this.params.platformUserId = parseInt(res.platformUserId)
this.params.managerId = parseInt(res.managerId)
this.params.invenstemUserId = parseInt(res.invenstemUserId)
this.params.sysCode = parseInt(res.sysCode)
this.params.au = res.au
this.params.specialObj = res.specialObj ? 'true' : 'false'
this.stepCurrent = parseInt(res.stepCurrent)
this.stepTotal = parseInt(res.stepTotal)








await this.questionNewList()
_this.loading = false
} else {
_this.$vux.toast.show({
type: 'warn',
text: '用户信息获取失败'
})
}
})
}
}, this.initTime)
},
$_evaluation_test () {
this.$router.push({path: '/evaluation/question', query: this.params})
},
async questionNewList () {
const params = {
sysCode: this.params.sysCode,
managerAdminUserId: this.params.managerId
}
const resp = await questionNewList(params, this.params.au)
if (resp.code === 0) {
this.question = resp.data.list[0]
this.params.version = resp.data.list[0].queationVersion 
} else {
this.$vux.toast.show({
type: 'warn',
text: '获取问卷失败'
})
return Promise.reject('获取问卷失败')
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/Evaluation/One.vue